export default "__VITE_ASSET__CkpgIZMI__"